/**
 * Entry IIFE para checkout JVZoo.
 *
 * <script src=".../pixel.jvzoo-checkout.global.js?pixelId=pix_…&workspaceId=ws_…"></script>
 *
 * Ambos os identificadores são opcionais. O preset auto-inicializa e nunca
 * coleta ou processa dados de cartão.
 */

import { createJvzooCheckoutSettings } from './jvzoo-checkout-settings';
import {
  findPresetScript,
  readPixelIdFromScriptSrc,
  readWorkspaceIdFromScriptSrc,
  startBuygoodsPreset,
} from './start-preset';

const SCRIPT_PATTERN = /pixel\.jvzoo-checkout/;

const script =
  typeof document !== 'undefined'
    ? findPresetScript(document, SCRIPT_PATTERN)
    : null;

startBuygoodsPreset({
  name: 'jvzoo-checkout',
  settings: createJvzooCheckoutSettings({
    ...(script
      ? { workspaceId: readWorkspaceIdFromScriptSrc(script.src) ?? undefined }
      : {}),
    ...(script
      ? { pixelId: readPixelIdFromScriptSrc(script.src) ?? undefined }
      : {}),
  }),
  hopToTop: false,
  scriptPattern: SCRIPT_PATTERN,
});
